import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';
import styles from './UnderApprovalProducts.module.scss';
import ManageTable from '../../../../views/Manage/ManageTable';
import { Loader } from 'react-feather';

const UnderApprovalProducts = () => {
    const [loading, setLoading] = useState(true);

    // State to track dropdown open state for each row
    const [dropdownOpen, setDropdownOpen] = useState({});

    // Function to toggle dropdown for a specific row
    const toggleDropdown = (rowId) => {
        setDropdownOpen((prevState) => ({
            ...prevState,
            [rowId]: !prevState[rowId],
        }));
    };

    const data = [
        {
            id: 1,
            name: 'Blue Colored Headphones',
            sku: 'Example123',
            productImg: require("../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            dateCreated: '08/06/2024',
            price: '$33.33',
            shipping: '$1',
            featuredPrice: '$38.33',
            competitivePrice: '$34.00',
            lowestPrice: '$30.33',
            stock: '300',
            status: 'Under approval',
        },
        {
            id: 2,
            name: 'Blue Colored Headphones',
            sku: 'Example123',
            productImg: require("../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            dateCreated: '08/06/2024',
            price: '$33.33',
            shipping: '$1',
            featuredPrice: '$38.33',
            competitivePrice: '$34.00',
            lowestPrice: '$30.33',
            stock: '300',
            status: 'Under approval',
        },
    ];

    const columns = [
        {
            name: 'Sr. no.',
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: 'Product Image',
            cell: (row) => <img src={row.productImg} alt={row.name} className={styles.productImg} />,
        },
        {
            name: 'Product Name',
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: 'SKU',
            selector: (row) => row.sku,
            sortable: true,
        },
        {
            name: 'Date Created',
            selector: (row) => row.dateCreated,
            sortable: true,
        },
        {
            name: 'Price + Shipping fee',
            cell: (row) => (
                <div className={styles.priceContainer}>
                    <div className={styles.priceShippingRow}><span className={styles.price}>{row.price} </span> + {row.shipping}</div>
                    <div className={styles.priceDetails}>
                        Featured price: {row.featuredPrice}
                        <br />
                        Competitive: {row.competitivePrice}
                        <br />
                        Lowest price: {row.lowestPrice}
                    </div>
                </div>
            ),
        },
        {
            name: 'Stock',
            selector: (row) => row.stock,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
        },
        {
            name: 'Action',
            cell: (row) => (
                <Dropdown isOpen={dropdownOpen[row.id]} toggle={() => toggleDropdown(row.id)} className={styles.actionDropdown}>
                    <DropdownToggle caret className={styles.dropdownButton}>
                        Action
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem>Edit</DropdownItem>
                        <DropdownItem>Deactivate</DropdownItem>
                        <DropdownItem>Delete</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            ),
        },
    ];

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <div className={styles.underApprovalProductsContainer}>

            <Container fluid className={styles.totalProducts}>
                <span>Total Products: 30</span>
            </Container>

            <Container fluid className={styles.underApprovalText}>
                <p>
                    Your products listed below are currently under review. Our team is ensuring they meet our quality and
                    compliance standards. You will be notified once the approval process is complete. Thank you for your patience
                    and for maintaining our high standards of quality and integrity.
                </p>
            </Container>

            {loading ? <Loader /> :
                <ManageTable
                    name={'Under Approval Products'}
                    columns={columns}
                    tableData={data}
                />
            }
        </div>
    );
};

export default UnderApprovalProducts;
